import React from "react";
import SignInForm from "./sign-in-form.component";
import { useFormik } from "formik";
import useLoadingError from "src/hooks/useLoadingError";
import { useAppDispatch } from "src/store/hook";
import { loginSchema } from "src/validations/login-schema";
import { useCustomerLoginMutation } from "src/services/api-service/customer-auth";
import { persistToken } from "src/utils";
import { setAuthCusToken, setCusUser } from "src/store/features/auth/customer";
import { useNavigate } from "react-router-dom";
import { IResponse } from "src/services/types";
import { USER_STATUS } from "src/types";
import { useGetAllCarriersMutation } from "src/services/api-service/quotations";

const SignInFormContainer = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { loading, error, reset, startLoading, stopLoading } =
    useLoadingError();
  const [login] = useCustomerLoginMutation<any>();
  const [getAllCarriers] = useGetAllCarriersMutation<any>();

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: loginSchema,
    validateOnBlur: true,
    validateOnChange: true,
    validateOnMount: true,
    onSubmit: (values) => {
      startLoading();
      login(values)
        .unwrap()
        .then((data) => {
          persistToken(data?.data?.access_token);
          dispatch(setCusUser(data?.data));
          dispatch(setAuthCusToken(data?.data?.access_token));
          getAllCarriers({});
          navigate("/quotations");
        })
        .catch((err: IResponse) => {
          if (err?.data?.is_accepted == USER_STATUS.PENDING_APPROVAL) {
            navigate("/pending-approval");
          } else if (err?.data?.is_accepted == USER_STATUS.REJECTED) {
            navigate("/rejected");
          }
        })
        .finally(() => {
          stopLoading();
        });
    },
  });

  return (
    <SignInForm
      formik={formik}
      error={error}
      resetError={reset}
      loading={loading}
    />
  );
};

export default SignInFormContainer;
